import axiosInstance from '@api/axios-instance.ts';

let debounceTimer: ReturnType<typeof setTimeout>;
let lastName = '';
let lastResult: boolean | string;

export const validateFolderNameServer = (name: string, parentId: string) => {
  return new Promise<boolean | string>((resolve) => {
    if (debounceTimer) clearTimeout(debounceTimer);

    debounceTimer = setTimeout(async () => {
      const trimmedName = name.trim();

      if (!trimmedName) {
        resolve('notOnlySpaces');
        return;
      }

      if (lastName === `${parentId}_${trimmedName}`) {
        resolve(lastResult);
        return;
      }

      try {
        const response = await axiosInstance.post(
          `/media-library/folders/nameValidation`,
          { name: trimmedName, parentId }
        );

        lastName = `${parentId}_${trimmedName}`;
        lastResult = response.data?.valid === true ? true : 'nameExists';

        resolve(lastResult);
      } catch (error) {
        resolve('serverError');
      }
    }, 500);
  });
};

export const validateJsonFormat = (value: string) => {
  try {
    JSON.parse(value);
    return true;
  } catch {
    return 'validation_invalid_json_format';
  }
};

export const validatePort = (value: number) => {
  if (!value) return 'required';

  if (value < 1 || value > 65535) {
    return 'validation_invalid_port';
  }

  return true;
};

export const validateIPAddress = (value: string) => {
  if (!value) return 'required';

  // IPv4 regex — строгая проверка от 0 до 255 в каждой группе
  const ipv4Regex =
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

  if (!ipv4Regex.test(value.trim())) {
    return 'invalid_ip_address';
  }

  return true;
};
